import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Radio,
  Typography,
  Spin,
  Row,
  Col,
  message,
  Checkbox,
} from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { routes } from "../../routes/Routes";
import moment from "moment";
import LeftLayout from "../pageHeader/LeftLayout";
import _NewapplicationService from "../../modules/NewapplicationService";
import CurrencyInput from "../../components/CurrencyInput";
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import ApplicationProgressBar from "./ApplicationProgressBar";
import { LeftOutlined, RightOutlined, ArrowRightOutlined } from "@ant-design/icons";
import ButtonComponent from "../../components/Button/Button";

const { Title } = Typography;

const Questionnaire = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [responses, setResponses] = useState({});
  const [questionsData, setQuestionsData] = useState([]);
  const [applStatusId, setApplStatusId] = useState(null);
  const ApplicationId = localStorage.getItem("ApplicationId");
  const applicationId = localStorage.getItem("Id");
  const ApplicationFlowType = localStorage.getItem("applicationFlowType");

  const location = useLocation();
  let data = location.state;
  let applnObjId = "";
  let activeKeyTab = null;
  let fromDashboard = false;

  if (data && data.applicationObjId) {
    applnObjId = data.applicationObjId;
  }

  if (data && data.isFromDashboard) {
    fromDashboard = data.isFromDashboard;
  }

  if (data && data.activeKey) {
    activeKeyTab = data.activeKey;
  }

  const [appObjId] = useState(applnObjId);
  const [isFromDashboard] = useState(fromDashboard);
  const [tabActiveKey] = useState(activeKeyTab);

  useEffect(() => {
    fetchQuestions();
    GetQuestionsByApplicationID();
  }, []);

  useEffect(() => form.resetFields(), [questionsData]);

  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getAllQuestions();
      if (res.data?.IsSuccess && Array.isArray(res.data.Obj)) {
        setQuestions(res.data.Obj);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const GetQuestionsByApplicationID = async () => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getQuestionsByApplicationID(applicationId);
      const data = res.data;

      if (Array.isArray(data) && data.length > 0) {
        setApplStatusId(data && data[0] && data[0].Application_Status_Id);
        const initialResponses = {};
        const formValues = { question: {} };

        data.forEach((item) => {
          const questionId = item.QuestionId;
          const answer = item.Answer ? "yes" : "no";
          const amount = item.Amount || "";
          const details = item.Description || "";

          // Responses state
          initialResponses[questionId] = {
            answer,
            amount,
            details,
          };

          // Form values for pre-fill
          formValues.question[questionId] = {
            answer,
            amount,
            details,
          };
        });

        setResponses(initialResponses);
        form.setFieldsValue(formValues); // This pre-fills the form
      } else {
        // First time visit — nothing to set
        setResponses({});
        form.resetFields();
      }
    } catch (err) {
      console.error("Error fetching question data:", err);
    } finally {
      setLoading(false);
    }
  };

  // const handleOptionChange = (id, value) => {
  //   setResponses((prev) => ({
  //     ...prev,
  //     [id]: { ...prev[id], answer: value },
  //   }));

  //   // Validate the changed field
  //   form.validateFields([["question", id, "answer"]]);

  //   // Also clear any previous details/amount if changing from "yes" to "no"
  //   if (value === "no") {
  //     setResponses((prev) => ({
  //       ...prev,
  //       [id]: { answer: "no", details: "", amount: "" },
  //     }));
  //     form.setFieldsValue({
  //       question: {
  //         [id]: {
  //           amount: undefined,
  //           details: undefined,
  //         },
  //       },
  //     });
  //   }
  // };

  const handleOptionChange = (id, value) => {
    // update AntD form value FIRST
    form.setFieldsValue({
      question: {
        [id]: {
          answer: value,
        },
      },
    });

    // update local state
    setResponses((prev) => ({
      ...prev,
      [id]: { ...prev[id], answer: value },
    }));

    // clear fields if "no"
    if (value === "no") {
      setResponses((prev) => ({
        ...prev,
        [id]: { answer: "no", details: "", amount: "" },
      }));

      form.setFieldsValue({
        question: {
          [id]: {
            amount: undefined,
            details: undefined,
          },
        },
      });
    }
  };


  const handleInputChange = (id, field, value) => {
    setResponses((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));

    form.validateFields([["question", id, field]]);
  };


  const onBack = () => {
    if (isFromDashboard) {
      history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
    } else {
      history.push(routes.balanceSheetTotalLiabilities.path);
    }
  }

  const onFinish = async () => {
    try {
      await form.validateFields(); // Validate all fields first

      const payload = {
        ApplicationId: applicationId,
        IsQuestionairCompleted: true,
        IsAllStepsCompleted: true,
        listquestions: Object.entries(responses).map(([questionId, data]) => ({
          QuestionId: parseInt(questionId),
          ApplicationId: applicationId,
          Answer: data.answer === "yes",
          Description: data.answer === "yes" ? data.details : null,
          Amount: data.answer === "yes" ? data.amount : null,
        })),
      };

      console.log("payload", payload);

      setLoading(true);
      const res = await _NewapplicationService.addOrUpdateQuestions(payload);
      if (res.data.IsSuccess) {
        if (isFromDashboard) {
          history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
          localStorage.setItem("fromUserLoginScreen", true);
          localStorage.setItem("fromBalanceSheetScreen", false);

        } else {
          history.push({ pathname: routes.dashboard.path, state: { activeKey: "2" } });
          localStorage.setItem("fromUserLoginScreen", false);
          localStorage.setItem("fromBalanceSheetScreen", true);
        }
        localStorage.setItem("ApplicationObjId", applicationId);
        localStorage.setItem("isFromMyApplicationsList", false);
        localStorage.setItem("IsQuestionairCompleted", true);
        localStorage.setItem("IsFromManualFlow", true);
        localStorage.setItem("isAllStepsCompleted", JSON.stringify(true));

        message.success(res.data.Message);
      }
    } catch (error) {
      console.error("Validation failed or submission error:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderQuestion = (q) => {
    const response = responses[q.Id] || {};

    return (
      <div key={q.Id}>
        {/* <Form.Item
          label={
            <span>
              {q.QuestionText}
            </span>
          }
          name={["question", q.Id, "answer"]}
          rules={[{ required: true, message: "Please Select Yes or No" }]}
          validateTrigger="onSubmit"
        >
          
          <Radio.Group
           onChange={(e) => handleOptionChange(q.Id, e.target.value)}
            value={response.answer}
          >
            <Radio value="yes">Yes</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        </Form.Item> */}

        <Form.Item
          name={["question", q.Id, "answer"]}
          rules={[{ required: true, message: "Please Select Yes or No" }]}
          validateTrigger="onSubmit"
        >
          <div className="question-row">
            <span>{q.QuestionText}</span>

            <Radio.Group
              onChange={(e) => handleOptionChange(q.Id, e.target.value)}
              value={response.answer}
            >
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </Radio.Group>
          </div>
        </Form.Item>

        {response.answer === "yes" && (
          <>
            <Form.Item
              label={
                <span>
                  Amount
                </span>
              }
              name={["question", q.Id, "amount"]}
              rules={[{ required: true, message: "Enter Amount is required" }]}
              validateTrigger="onSubmit"
              className="w50"
            >
              <CurrencyInput
                value={response.amount}
                onChange={(val) => handleInputChange(q.Id, "amount", val)}
                placeholder="Enter Amount"
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Comments
                </span>
              }
              name={["question", q.Id, "details"]}
              rules={[{ required: true, message: "Comments are required" }]}
              validateTrigger="onSubmit"
              className="w50"
            >
              <Input.TextArea
                autoSize={{ minRows: 1, maxRows: 5 }}
                maxLength={500}
                value={response.details}
                onChange={(e) => handleInputChange(q.Id, "details", e.target.value)}
                placeholder="Enter Comments"
              />
            </Form.Item>
          </>
        )}
      </div>
    );
  };

  const assetQuestions = questions.filter((q) => q.QuestionType === "Asset");
  const liabilityQuestions = questions.filter(
    (q) => q.QuestionType === "ConditionalLiability"
  );

  return (
    <LeftLayout>
      {/* {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                    <div style={{
                        position: "absolute",
                        top: 5,
                        right: 20,
                        margin: 0,
                        zIndex: 1000,
                        maxWidth: "1000px",
                        padding: "8px 16px",
                    }}>
                       <ApplicationProgressBar />
                        <Title level={3} style={{ margin: 0 }}>
                            <ShowApplicationId />
                        </Title>
                    </div>
                )} */}
      <div>
        {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
          <div>
            <ApplicationProgressBar />
            <Title level={5}>
              {/* <ShowApplicationId /> */}
            </Title>
          </div>
        )}
      </div>
      <div className="pageSubBackgroundForBalanceAssetPageWrapper">
        <div className="pageSubBackgroundForBalanceAssetPageCard">

          <Row>
            <Col span={24}>
              <Spin spinning={loading}>
                <Title className="mt50" level={3} style={{ marginBottom: 30, }}>
                  Balance Sheet – Questionnaire
                </Title>

                <Form form={form} layout="vertical" onFinish={onFinish}>
                  <h2 style={{ fontWeight: "bold", marginBottom: 20, marginLeft: "20px" }}>Assets:</h2>
                  <div className="balancesheetpdm">{assetQuestions.map(renderQuestion)}</div>


                  <h2 style={{ fontWeight: "bold", margin: "40px 0 20px", marginLeft: "20px" }}>
                    Contingent Liabilities:
                  </h2>

                  <div className="balancesheetpdm">{liabilityQuestions.map(renderQuestion)}</div>


                  {/* <Form.Item style={{ marginTop: 30 }}>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end", gap: "16px", padding: "24px" }}

                    >
                      <ButtonComponent
                        onClick={onBack}
                        type="default"
                        text="Go Back"
                        icon={<LeftOutlined />}
                      />
                      <ButtonComponent
                        type="primary"
                        htmlType="submit"
                        title="Save And Proceed"
                        disabled={applStatusId != null && ![1,2,4,9].includes(applStatusId) ? true : false}
                      />
                    </div>
                  </Form.Item> */}
                  {ApplicationFlowType === "Manually" && (
                    <Form.Item
                      name="ihereby"
                      valuePropName="checked"
                      className="mt20"
                      rules={[
                        {
                          validator: (_, value) =>
                            value
                              ? Promise.resolve()
                              : Promise.reject(
                                new Error("Please confirm terms & conditions")
                              ),
                        },
                      ]}
                    >
                      <Checkbox>
                        I hereby authorize the Bank to obtain and review my Credit Bureau Report (CBR), credit score,
                        and related credit information from authorized credit bureaus and third-party sources for the purpose of evaluating and processing my application.
                      </Checkbox>
                    </Form.Item>
                  )}

                  <Form.Item>
                    <Row justify="end" gutter={16}>
                      <Col>
                        <ButtonComponent
                          type="default"
                          onClick={onBack}
                          icon={<LeftOutlined />}
                          text="Go Back"
                        />
                      </Col>
                      <Col>
                        <ButtonComponent
                          type="primary"
                          htmlType="submit"
                          disabled={applStatusId != null && ![1,2, 4, 9].includes(applStatusId) ? true : false}
                          text={
                            <span>
                              Save And Proceed <ArrowRightOutlined />
                            </span>
                          }
                          // text="Save And Proceed"
                          icon={<RightOutlined />}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                </Form>
              </Spin>
            </Col>
          </Row>
        </div>
      </div>
    </LeftLayout>
  );
};

export default Questionnaire;